import { createSlice } from '@reduxjs/toolkit'

export const ContrastSlice = createSlice({
  name: 'contrast',
  initialState: {
    value: false,
  },
  reducers: {
    aaaChecked: (state, action) => {
      state.value = action.payload
    },
    reduxLogout: state => {
      // From here we can take action only at this "counter" state
      // But, as we have taken care of this particular "logout" action
      // in rootReducer, we can use it to CLEAR the complete Redux Store's state
    }
  },
})

export const { aaaChecked, reduxLogout } = ContrastSlice.actions

export default ContrastSlice.reducer